import { Component, Input, OnInit } from '@angular/core';
import { CountryDisplayMode } from 'app/entities/event/category-registrations.component';

export type ClubMember = {
  clubName: string;
  countryCode?: string;
};

export type WithSettings = {
  settings: {
    countryDisplayMode?: CountryDisplayMode;
    externalRegistrationsEnabled?: boolean;
  };
};

@Component({
  selector: 'country-and-club-label',
  templateUrl: 'country-and-club-label.html',
  standalone: false
})
export class CountryAndClubLabelComponent implements OnInit {
  @Input() clubMember: ClubMember;
  @Input() event: WithSettings;
  countryDisplayMode: CountryDisplayMode;

  ngOnInit() {
    const internationalEvent = this.event.settings?.externalRegistrationsEnabled ?? false;
    this.countryDisplayMode =
      this.event.settings?.countryDisplayMode ||
      (internationalEvent ? CountryDisplayMode.COUNTRY_AND_CLUB : CountryDisplayMode.CLUB);
  }
}
